export const ROLES = {
  ADMIN: "Admin",
  REMOTE_WORKER: "Remote Worker",
  LOCAL_CAREGIVER: "Local Caregiver",
  FAMILY: "Family",
  RESIDENT: "Resident User",
  MANAGEMENT: "Management"
};
